import { h } from './element.mjs'; 
import { svgIcon } from '../icons.mjs';
class FormInput {
    constructor(className, label, type = 'text', onChange = () => { }) {
        this.el = h('div', 'field');
        this.input = h('input').attr({ type });
        this.el
            .children(
                h('label').child(label),
                h('div', `${className} inputWrap`).child(this.input)
        );
        this.onChange = onChange; 
        this.input.on('change', this.handleChange.bind(this));
        this.hasSingleValue = true;
    }
    setValue(value) {
        this.input.val(value);
        return this;
    } 
    getValue() {
        return this.input.val();
    }
    handleChange(e){
        this.onChange();
        this.hasSingleValue = true;
    }
    hide() {
        this.el.hide(); 
    } 
    show() {
        this.el.show(); 
    }
    multipleValues(b = false) {
        if (b) {
            this.hasSingleValue = false;
            this.input.val('');
            this.input.el.placeholder = 'Mixed';
        }
        return this;
    }
}

class Combobox {
    constructor(className, label, selectedKey = '', options = [], onChange = () => { }) { 
        this.labelText = label;
        this.selectedKey = selectedKey;
        this.options = options;
        this.onChange = onChange;

        this.select = h('select', className) 
        this.select.on('change', this.handleChange.bind(this));
        this.label = h('label').child(label);
        this.el = h('div', 'field')
            .children(this.label.el, h('div', 'inputWrap').child(this.select)); 
        this.populate(options); 
        this.hasSingleValue = true;
    }
    handleChange(e) {
        const selectedKey = e.target.value;
        this.selectedKey = selectedKey;

        const selected = this.options.find(opt => {
            return typeof opt === 'string'
                ? opt === selectedKey
                : opt.key === selectedKey;
        });
        this.hasSingleValue = true;
        this.onChange(selectedKey); 
    }
    async populate(options) {
        this.options = options;
        this.select.el.innerHTML = ''; 
        const blankOption = h('option')
            .attr('value', '')
            .child('-- Select --');
        if (!this.selectedKey) {
            blankOption.attr('selected', 'selected');
        }
        this.select.child(blankOption);
        options.forEach(opt => {
            let key, label, data;
            if (typeof opt === 'string') {
                key = label = opt;
                data = null;
            } else {
                ({ key, label } = opt);
            }

            const option = h('option')
                .attr('value', key)
                .child(label);

            if (key === this.selectedKey) {
                option.attr('selected', 'selected');
            }

            this.select.child(option);
        });

        return this;
    } 
    setValue(key) {
        this.selectedKey = key;
        this.select.el.value = key;
        return this;
    }

    getValue() {
        return this.selectedKey === '' ? '-1' : this.selectedKey;
    }
    hide() {
        this.el.hide();
    }
    show() {
        this.el.show();
    }
    multipleValues(b = false) {
        if (b) {
            this.hasSingleValue = false;
            this.select.el.value='';
            this.select.el.placeholder = 'Mixed';
        }
        return this;
    }
}


class Checkbox {
    constructor(className, label, checked = false, change = () => { } ) {
        this.el = h('label','d-flex flex-row gap-1 align-items-center');
        this.input = h('input', className).attr({ type: 'checkbox' });
        this.input.el.checked = !!checked;
        this.change = change;
        this.input.on('change', (e) => this.change(e));
        this.el.child(this.input).child(` ${label}`);
        this.hasSingleValue = true;
    }
    setValue(checked) { 
        this.input.el.checked = !!checked;
        this.input.el.indeterminate = false;
        return this;
    }
    getValue() {
        return this.input.el.checked;
    }
    hide() {
        this.el.hide();
    }
    show() {
        this.el.show();
    }
    multipleValues(b = false) {
        this.input.el.indeterminate = b;
        this.hasSingleValue = !b;
        return this;
    }
}

class Button {
    constructor(label, className = 'btn') {
        this.el = h('button', className).child(label);
    } 
    on(e, fn) {
        this.el.on(e, fn);
    }
}
class ToggleButtonGroup {
    constructor(name, options = [], defaultValue = null, vertical = false, change = () => { }) {
        this.name = name;
        this.value = defaultValue;
        this.change = change;

        this.group = h('div', `btn-group btn-group-sm ${vertical ? 'vertical' : ''}`)
            .attr({
                role: 'group',
                'aria-label': name,
            });

        this.buttons = options.map(opt => { 
            const btn = h('button', 'btn btn-sml btn-outline-secondary')
                .attr('type', 'button')
                .children(opt.icon.render())
                .on('click', () => this.setValue(opt.value));

            if (opt.value === defaultValue) {
                btn.addClass('active');
            }

            this.group.child(btn);
            return btn;
        });
    }

    setValue(value) {
        this.value = value;
        this.buttons.forEach(btn => {
            btn.active(btn.data('value') === value);
        });
        this.change();
    }

    getValue() {
        return this.value;
    }

    render() {
        return this.group.el;
    }
    hide() {
        this.group.hide();
    }
    show() {
        this.group.show();
    }
}
class ToggleButton {
    constructor(label, child, defaultValue = false, onChange = () => { }) {
        this.value = defaultValue;
        this.onChange = onChange;

        this.button = h('button', 'btn btn-sml btn-outline-secondary')
            .attr('type', 'button')
            .children(child.render())
            .on('click', () => this.toggle());

        if (this.value) {
            this.button.addClass('active');
        }
    }

    toggle() {
        this.value = !this.value;
        this.button.toggleClass('active', this.value);
        this.onChange(this.value);
    }

    getValue() {
        return this.value;
    }

    setValue(val) {
        this.value = val;
        this.button.toggleClass('active', this.value);
        this.onChange(this.value);
    }

    render() {
        return this.button.el;
    }
    hide() {
        this.button.hide();
    }
    show() {
        this.button.show();
    }
}
export { Button, Checkbox, Combobox, FormInput, ToggleButtonGroup, ToggleButton };